import React, { createContext, useContext } from 'react';

// ECDEX-3740: true when `cdx_cp_mastodon_report` is on for the report's
// account. The report view and the server-rendered report PDF both provide
// it, so they render the same components. Off is the default, so anything
// rendered outside a provider keeps the Bootstrap markup.
const MastodonReportContext = createContext(false);

export const MastodonReportProvider = ({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}) => (
  <MastodonReportContext.Provider value={enabled}>
    {children}
  </MastodonReportContext.Provider>
);

export const useMastodonReport = (): boolean =>
  useContext(MastodonReportContext);

export default MastodonReportContext;
